// Custom Navigation Drawer / Sidebar with Image and Icon in Menu Options
// https://aboutreact.com/custom-navigation-drawer-sidebar-with-image-and-icon-in-menu-options/

import React from 'react';
import {
  SafeAreaView,
  View,
  StyleSheet,
  Image,
  Text,
  Linking,
  TouchableOpacity
} from 'react-native';

import {
  DrawerContentScrollView,
  DrawerItemList,
  DrawerItem,
} from '@react-navigation/drawer';
import MyText from './MyText';
import { MaterialIcons, Entypo, Feather, FontAwesome, MaterialCommunityIcons, AntDesign, FontAwesome5 } from '@expo/vector-icons'; 

import * as SecureStore from 'expo-secure-store';
import axios from 'axios';

import MyRequests from './assets/icons/MyRequests.svg';
import NewRequest from './assets/icons/NewRequest.svg';
import Dashboard from './assets/icons/Dashboard.svg';
import Documents from './assets/icons/Documents.svg';
import MySVG from './assets/MySVG';
import * as logo from './assets/icons/mdata_logo.png';

const CustomBottomSheetContent = (props) => {

    const Logout = () => {
        props.bottomSheet.current?.dismiss();
        axios.get('/api/user/logout.php')
        .then(async() => {
            await SecureStore.deleteItemAsync('email');
            await SecureStore.deleteItemAsync('password');
            props.setUser(null);
            props.navigation?.current?.navigate('Landing Page');
        })
  }

  return (
    <SafeAreaView style={{ flex: 1, zIndex: 2 }}>
        <View style={{flex: 1, paddingHorizontal: 30, paddingVertical: 10, marginBottom: 0}}>
            {
                props.user &&
                <TouchableOpacity style={styles.touchable}>
                    <FontAwesome name="user-circle" size={20} color="#461b6f" style={styles.icon}/>
                    <MyText style={styles.label}>
                        {props.user.firstName} {props.user.lastName}
                    </MyText>
                </TouchableOpacity>
            }
            {
                props.user && !props.user.isVGroup?
                <>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('My Requests');}}>
                        <MySVG source={MyRequests} style={styles.icon} />
                        <MyText style={styles.label}>
                            My Requests
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('New Request');}}>
                        <MySVG source={NewRequest} style={styles.icon} />
                        <MyText style={styles.label}>
                            New Request
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('Dashboard');}}>
                        <MySVG source={Dashboard} style={styles.icon} />
                        <MyText style={styles.label}>
                            Dashboard
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('Documents');}}>
                        <MySVG source={Documents} style={styles.icon} />
                        <MyText style={styles.label}>
                            Documents Library
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('My Notifications');}}>
                        <MaterialCommunityIcons name="bell" size={20} color="#461b6f" style={styles.icon}/>
                        <MyText style={styles.label}>
                            My Notifications
                        </MyText>
                    </TouchableOpacity>
                </>
                :<></>
            }
            {
                props.user && props.user.isVGroup?
                <>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('Manage Requests');}}>
                        <MySVG source={MyRequests} style={styles.icon} />
                        <MyText style={styles.label}>
                            Manage Requests
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('New Request');}}>
                        <MySVG source={NewRequest} style={styles.icon} />
                        <MyText style={styles.label}>
                            New Request
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('Manage Users');}}>
                        <FontAwesome5 name="users-cog" size={16} color="#461b6f" style={styles.vectorIcon} />
                        <MyText style={styles.label}>
                            Manage Users
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('Dashboard');}}>
                        <MySVG source={Dashboard} style={styles.icon} />
                        <MyText style={styles.label}>
                            Dashboard
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('Documents');}}>
                        <MySVG source={Documents} style={styles.icon} />
                        <MyText style={styles.label}>
                            Documents Library
                        </MyText>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => {props.bottomSheet.current?.dismiss(); props.navigation?.current?.navigate('My Notifications');}}>
                        <MaterialCommunityIcons name="bell" size={20} color="#461b6f" style={styles.icon}/>
                        <MyText style={styles.label}>
                            My Notifications
                        </MyText>
                    </TouchableOpacity>
                </>
                :<></>
            }
            {
                props.user &&
                <TouchableOpacity style={styles.touchable} onPress={Logout}>
                    <MaterialIcons name="logout" size={13} color="white" style={[styles.icon, styles.logout]}/> 
                    <MyText style={styles.label}>
                        Logout
                    </MyText>
                </TouchableOpacity>
            }
        </View>
        <View style={{flex: 0, paddingHorizontal: 30, paddingVertical: 0, marginBottom: 0}}>
            <TouchableOpacity onPress={() => {Linking.openURL('https://mdata.gr')}} style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 10}}>
                <MyText style={{ fontSize: 7, textAlign: 'center', color: '#461b6f', marginRight: 3, marginBottom: 0}}>
                    Developed by
                </MyText>
                <Image source={require("./assets/icons/mdata_logo.png")} style={{width: 10*3.14, height: 10}}/>
            </TouchableOpacity>
        </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  iconStyle: {
    width: 15,
    height: 15,
    marginHorizontal: 5,
  },
  customItem: {
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
    marginBottom: 10
  },
  vectorIcon: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
    marginBottom: 10,
    paddingTop: 2
  },
  logout: {
    backgroundColor: '#461b6f',
    borderRadius: 14,
    paddingLeft: 5,
    paddingTop: 3
  },
  touchable: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 11
  },
  label: {
    marginLeft: 10,
    color: '#461b6f',
    borderBottomWidth: 0.7,
    borderColor: '#e0dde3',
    flex: 1,
    paddingBottom: 13
  }
});

export default CustomBottomSheetContent;
